module.exports = __webpack_public_path__ + "static/media/thirdWitnessLogo.2388dffc.webp";